export type GraphViewMode = 'MonthDetail' | 'DayDetail';

export const GraphViewMode = {
  MonthDetail: 'MonthDetail' as GraphViewMode,
  DayDetail: 'DayDetail' as GraphViewMode,
}